import React, { useState, FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { PageProps } from "../types/auth";

import styles from './styles/JoinPage.module.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const JoinPage: React.FC<PageProps> = ({ user, token, selectedOrgID }) => {
  const [inviteCode, setInviteCode] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [success, setSuccess] = useState<string>("");
  const navigate = useNavigate();

  const handleJoin = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError("");
    setSuccess("");

    try {
      const response = await fetch(`${API_BASE_URL}/api/organizations/join`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "X-Org-ID": selectedOrgID?.toString() || "",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ invite_code: inviteCode }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setError(errorData.error || "Failed to join the organization.");
        return;
      }

      setSuccess("Successfully joined the organization!");
      setInviteCode("");
    } catch (err) {
      setError("An unexpected error occurred.");
    }
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Join Organization</h1>
      {error && <p className={styles.errorMessage}>{error}</p>}
      {success && <p className={styles.successMessage}>{success}</p>}
      <form onSubmit={handleJoin} className={styles.form}>
        <div className={styles.formGroup}>
          <label className={styles.label}>Invite Code:</label>
          <input
            type="text"
            value={inviteCode}
            onChange={(e) => setInviteCode(e.target.value)}
            required
            className={styles.input}
          />
        </div>
        <button type="submit" className={styles.submitButton}>Join</button>
      </form>
    </div>
  );
};

export default JoinPage; 